import apiFetch from '../apiFetch'

export default function (token, organizedUnitId, financingCompanyId) {
  return apiFetch({ endPoint: 'FinanceCompany/AddUosToCompany/' + financingCompanyId + '?organizedUnitId=' + organizedUnitId, method: 'POST', body: null, token: token })
}
